module.exports = __webpack_public_path__ + "static/media/ChannelSong.Punjabi.16d4859c.jpg";